import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonPage, IonSpinner, IonTitle, IonToolbar, useIonToast } from '@ionic/react'
import Lightning from 'assets/icons/Lightning'
import { AuthContext } from 'contexts/AuthContext'
import useMerchantProfile from 'hooks/useMerchantProfile'
import { checkmarkOutline, chevronBackOutline, timerOutline } from 'ionicons/icons'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import { AccountStore } from 'stores/AccountStore'
import client from 'utils/Api'
import './NoHassleSetup.css'
import { providers } from './Providers'

const NoHassleSetup = ({ match }) => {
  const { authState } = useContext(AuthContext);
  const pid = match.params.id;
  const history = useHistory();
  const account = AccountStore.useState((s) => s.account);
  const axiosClient = client(authState.token);
  const [present,] = useIonToast();
  const [loading, setLoading] = useState(false);
  const { refetch } = useMerchantProfile(
    authState.user.uid,
    true
  );

  const advancedSetup = () => {
    history.push('/account/lsp/btcpay-setup', {
      provider: 'btcpay'
    })
  }

  const quickSetup = async () => {
    setLoading(true)
    const res = await axiosClient.post('/account/managed', {
      provider: pid,
      name: account?.merchant?.business_name,
      email: account?.email,
      currency: "USD",
      country: "US",
      business_type: 'company',
      metadata: {
        user_id: account?.merchant?.user_id
      }
    })
    refetch();
    present({
      color: "dark",
      duration: 5000,
      position: "top",
      message: pid === 'btcpay' ? "Greetings, shadowy super coder! Your BTC Pay Server is now connected." : "Success! Check your email to verify your " + providers[pid].name + " account.",
      icon: Lightning,
    });
    setLoading(false);
    if (res) {
      history.push('/notifications', { direction: 'back' });
      // history.push('/account/welcome', {
      //   opennode_account_id: res.data.opennode_account_id
      // });
    }
  }
  return (
    <IonPage className={'no-hassle-root'}>
      <IonHeader className={'ion-no-border'}>
        <IonToolbar className={'background-color'}>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              onClick={() => history.goBack()}><IonIcon icon={chevronBackOutline} /></IonButton>
          </IonButtons>
          <IonTitle>{providers[pid].name}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={'content-header ion-margin-top'}>
          <h1>{providers[pid].h1}</h1>
          <p>{providers[pid].p} <img src={providers[pid].img} alt={`${providers[pid].name} Logo`} className={'lsp-logo'} /></p>
        </div>
        <IonCard>
          <IonCardContent>
            <IonLabel><p>{providers[pid].label}</p></IonLabel>
            <br />
            <IonList lines="none">
              {providers[pid].benefits.map((item, i) => {
                return <IonItem disabled={!item.active} key={item.desc + i}><IonIcon
                  icon={item.active ? checkmarkOutline : timerOutline}
                  size="small" /><p>{item.desc}</p></IonItem>
              })}
            </IonList>
            <br />
            <IonButton
              disabled={loading}
              expand="block"
              onClick={() => pid === 'btcpay' ? advancedSetup() : quickSetup()}>{loading ? <IonSpinner name="crescent" /> : pid === 'btcpay' ? "Get Started" : "Select Provider"}</IonButton>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  )
}

export default NoHassleSetup
